import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { RestService } from 'src/app/services/rest.service';
import { GlobalvarsService } from 'src/app/services/globalvars.service';

@Component({
  selector: 'app-departments',
  templateUrl: './departments.component.html',
  styleUrls: ['./departments.component.css']
})
export class DepartmentsComponent implements OnInit {

  departments: any[] = [];

  constructor(    
    private rest: RestService,
    private globalvar: GlobalvarsService,
    private router: Router) { }

  ngOnInit(): void {
    let tmpToken:any
    this.globalvar.getToken.subscribe(retValue => tmpToken = retValue);

    console.log("init", tmpToken)
    this.rest.getDepartments(tmpToken.accessToken)
      .then(value => {
        this.departments.push(value)
      })
      .catch(err => {
        this.globalvar.storeToken('');
        this.router.navigateByUrl('/logon');
      })
  }

  edit(itemId:any) {
    console.log(itemId)
  }

  add() {
    console.log('add user')
  }

}
